export const ROLE_PARENT = 'parent'
export const ROLE_STUDENT = 'student'
export const ROLE_INSTRUCTOR = 'instructor'
export const ROLE_UNIVERSITY_STUDENT = 'universityStudent'

// Pre-migration value of ROLE_STUDENT. Accepted on read until
// migrate_parentStudent_role_to_student has run in every environment; new
// accounts are always created as ROLE_STUDENT.
export const LEGACY_ROLE_STUDENT = 'parentStudent'

export const UNIVERSITY_SUNSET_MESSAGE =
  'This product is no longer available for university usage'

export const UNSUPPORTED_ROLE_MESSAGE =
  'This account is not set up for Quillnote homeschool. Please contact support@quillnote.app for help.'

// 'student' is deliberately absent: it was the university role before the
// universityStudent migration and now identifies a homeschool student. Adding
// it back would lock every student out of the product.
const UNIVERSITY_ROLES = [ROLE_INSTRUCTOR, ROLE_UNIVERSITY_STUDENT]

const STUDENT_ROLES = [ROLE_STUDENT, LEGACY_ROLE_STUDENT]

export const isUniversityRole = (role) => UNIVERSITY_ROLES.includes(role)

export const isStudentRole = (role) => STUDENT_ROLES.includes(role)

export const routeForRole = (role) => {
  if (role === ROLE_PARENT) return '/parent/dashboard'
  if (isStudentRole(role)) return '/study-helper'
  return null
}
